/**
 * Traducciones en inglés para EmptyView
 */

export const emptyViewTranslationsEn = {
  noResults: {
    title: "Oops, it seems your search yielded no results...",
    description: "Try again by modifying the filters and/or keywords"
  },
  emptyState: {
    title: "Wow, everything is quiet here... very quiet...",
    description: "There are still no results in this section. You can change that by creating a new entry."
  }
};
